<template>
  <div class="v-container">
    <div class="loadding-spin" v-if="loading">
      <Circle4></Circle4>
    </div>
    <div class="card">
      <div class="card-body">
        <div class="title-body">
          <h3>DANH SÁCH LỜI NHẮN</h3>
          <div class="title-btn">
            <el-button @click="fn_tableShowFormSearch()" icon="el-icon-search"
              >ẩn/hiện tìm kiếm</el-button
            >
          </div>
        </div>
        <div class="main-body">
          <div class="main-body-search mb-3">
            <b-collapse
              v-bind:visible="mData.tableRules.showFormSearch"
              id="myFormSearch"
              class="b-shadow"
            >
              <b-card style="min-height: auto">
                <el-form
                  ref="myForm"
                  label-position="top"
                  @submit.native.prevent
                  label-width="100px"
                  :model="mData.tableRules.dataSearch.value"
                  :rules="mData.tableRules.dataSearch.valid"
                >
                  <b-row>
                    <b-col md="3">
                      <el-form-item label="Họ và tên">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['ho_ten']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Điện thoại">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['dien_thoai']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Email">
                        <el-input
                          v-model="mData.tableRules.dataSearch.value['email']"
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col md="3">
                      <el-form-item label="Nội dung">
                        <el-input
                          v-model="
                            mData.tableRules.dataSearch.value['noi_dung']
                          "
                          size="medium"
                          clearable
                          @input="forceUpdateUI"
                        ></el-input>
                      </el-form-item>
                    </b-col>
                    <b-col lg="6">
                      <el-form-item label="Ngày gửi">
                        <el-date-picker
                          v-model="
                            mData.tableRules.dataSearch.value['thoi_diem_tao']
                          "
                          type="daterange"
                          range-separator="-"
                          format="dd/MM/yyyy"
                          start-placeholder="Từ ngày"
                          end-placeholder="Đến ngày"
                          @input="$forceUpdate()"
                        >
                        </el-date-picker>
                      </el-form-item>
                    </b-col>
                  </b-row>

                  <el-form-item class="text-center mb-0">
                    <el-button
                      icon="el-icon-search"
                      type="primary"
                      native-type="submit"
                      v-ladda
                      @click="fn_tableSearch()"
                      >Tìm kiếm</el-button
                    >
                  </el-form-item>
                </el-form>
              </b-card>
            </b-collapse>
          </div>
          <div class="main-body-table">
            <div class="table-group-btn">
              <el-button
                type="danger"
                plain
                icon="el-icon-delete"
                :disabled="multipleSelection.length == 0"
                @click="dialogThongBao = true"
                style="text-transform: none"
                class="table-group-btn__delete"
                >Xóa nhiều lời nhắn</el-button
              >

              <el-select
                v-model="mData.tableRules.dataSearch.value['trang_thai']"
                placeholder="Trạng thái"
                @change="fn_changeTrangThai"
                size="medium"
                clearable
                class="table-group-btn__trangThai"
              >
                <el-option
                  v-for="item in trang_thai_arr"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>

              <el-select
                v-model="mData.tableRules.dataSearch.value['loai_loi_nhan']"
                placeholder="Loại lời nhắn"
                @change="fn_changeLoaiLoiNhan"
                size="medium"
                clearable
                class="table-group-btn__loiNhan"
              >
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-table
              :data="mData.tableRules.data"
              border
              max-height="540"
              style="width: 100%"
              @selection-change="handleSelectionChange"
              :row-class-name="tableRowClassName"
              @sort-change="fn_tableSortChange"
              :default-sort="{
                prop: mData.tableRules.defaultSort[0],
                order: mData.tableRules.defaultSort[1],
              }"
            >
              <el-table-column type="selection" width="55" align="center">
              </el-table-column>
              <el-table-column prop="" label="STT" width="50">
                <template slot-scope="scope">
                  <div class="text-center">
                    {{ mData.tableRules.offset + scope.$index + 1 }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column width="90" prop="trang_thai" label="Trạng thái">
                <template slot="header" slot-scope="">
                  <div>Trạng thái</div>
                </template>

                <template slot-scope="scope">
                  <div v-if="scope.row.trang_thai == 'moi'" class="text-box">
                    <p>Mới</p>
                  </div>

                  <div
                    v-if="scope.row.trang_thai == 'dang_xu_ly'"
                    class="text-box"
                  >
                    <p>Đang xử lý</p>
                  </div>
                  <div
                    v-if="scope.row.trang_thai == 'da_xu_ly'"
                    class="text-box"
                  >
                    <p>Đã xử lý</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Loại lời nhắn" align="center" width="120">
                <template slot-scope="scope">
                  <div
                    v-if="scope.row.loai_loi_nhan == 'loi_nhan'"
                    class="text-box"
                  >
                    <p>Landing page</p>
                  </div>
                  <div
                    v-if="scope.row.loai_loi_nhan == 'gop_y'"
                    class="text-box"
                  >
                    <p>Góp ý App</p>
                  </div>
                  <div
                    v-if="scope.row.loai_loi_nhan == 'thong_bao_loi'"
                    class="text-box"
                  >
                    <p>Báo lỗi App</p>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="ho_ten"
                label="Họ và tên"
                min-width="120"
                :sortable="mData.tableRules.allowSorting"
              ></el-table-column>
              <el-table-column
                prop="dien_thoai"
                label="Điện thoại"
                align="center"
                width="110"
              >
              </el-table-column>
              <el-table-column prop="email" label="Email" min-width="200">
              </el-table-column>
              <el-table-column prop="noi_dung" label="Nội dung" min-width="250">
              </el-table-column>
              <el-table-column
                prop="thoi_diem_tao"
                label="Ngày gửi"
                width="150"
                :sortable="mData.tableRules.allowSorting"
                align="center"
              >
                <template slot-scope="scope">
                  <div class="text-center">
                    {{
                      fn_date(scope.row.thoi_diem_tao),
                    }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="Thao tác" align="center" width="250px">
                <template slot-scope="scope">
                  <el-link
                    :href="scope.row.urlDetailLink"
                    :underline="false"
                    style="margin: 0 3px 0"
                    ><el-button
                      size="mini"
                      plain
                      @click="fn_handle('detail', scope.$index, scope.row)"
                      v-b-popover.hover.left="aLang.c_detail"
                    >
                      <i class="fa fa-eye"></i> </el-button
                  ></el-link>
                  <p
                    style="display: inline; margin: 0px 0px 0px 8px"
                    v-b-popover.hover.left="aLang.c_process"
                  >
                    <el-button
                      size="mini"
                      plain
                      @click="fn_update('dang_xu_ly', scope.$index, scope.row)"
                      :disabled="scope.row.trang_thai == 'dang_xu_ly'"
                      variant="outline-success"
                    >
                      <i class="fas fa-retweet"></i>
                    </el-button>
                  </p>
                  <p
                    style="display: inline; margin: 8px"
                    v-b-popover.hover.left="aLang.c_ok"
                  >
                    <el-button
                      size="mini"
                      plain
                      @click="fn_update('da_xu_ly', scope.$index, scope.row)"
                      :disabled="scope.row.trang_thai == 'da_xu_ly'"
                      variant="outline-success"
                      type="success"
                    >
                      <i class="fas fa-check-circle"></i>
                    </el-button>
                  </p>
                  <el-button
                    size="mini"
                    plain
                    @click="fn_handle('delete', scope.$index, scope.row)"
                    v-b-popover.hover.left="aLang.c_delete"
                    type="danger"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <div class="mt-2 text-right" v-if="mData.tableRules.allowPaging">
              <el-pagination
                @size-change="fn_tableSizeChange"
                :page-sizes="mData.tableRules.lengthMenu"
                :page-size="mData.tableRules.limit"
                :current-page="mData.tableRules.page"
                @current-change="fn_tableCurentChange"
                @prev-click="fn_tablePrevClick"
                @next-click="fn_tableNextClick"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :total="mData.tableRules.total"
                :pager-count="5"
              ></el-pagination>
            </div>
          </div>
          <el-dialog
            title="thông báo"
            :visible.sync="dialogThongBao"
            width="30%"
            center
          >
            <div style="word-break: break-word; text-align: center">
              Bạn có chắc chắn xóa nhiều lời nhắn?
            </div>

            <span slot="footer" class="dialog-footer">
              <el-button @click="dialogThongBao = false">Hủy</el-button>
              <el-button type="primary" @click="fn_removeMessages()"
                >Đồng ý</el-button
              >
            </span>
          </el-dialog>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
import { Circle4 } from "vue-loading-spinner";
import LanguageService from "../../../service/LanguageService";
import MethodService from "../../../service/MethodService";
import DataForm from "../../../dataForm/dataFormLoiNhan";
import eventBus from "../../../service/EventBus";
import moment from "moment";

export default {
  data() {
    return {
      aLang: LanguageService.lang,
      loading: true,
      dialogThongBao: false,
      trang_thai_arr: [
        {
          value: "moi",
          label: " Mới ",
        },
        {
          value: "dang_xu_ly",
          label: "Đang xử lý",
        },
        {
          value: "da_xu_ly",
          label: "Đã xử lý",
        },
      ],
      options: [
        {
          value: "loi_nhan",
          label: "Landing page",
        },
        {
          value: "gop_y",
          label: "Góp ý App",
        },

        {
          value: "thong_bao_loi",
          label: "Báo lỗi app",
        },
      ],
      mData: {
        tableRules: MethodService.copyObject(DataForm.tableRules),
      },
      urlDetail: "", // link mở sang tab mới khi bấm xem chi tiết lời nhắn
      multipleSelection: [],
    };
  },
  components: {
    Circle4,
  },
  methods: {
    tableRowClassName({ row, rowIndex }) {
      if (
        Number(row.delayXuLy) > 1 &&
        Number(row.delayXuLy) <= 2 &&
        row.trang_thai == "dang_xu_ly"
      ) {
        return "delayYellow";
      } else if (
        Number(row.delayXuLy) > 2 &&
        Number(row.delayXuLy) <= 7 &&
        row.trang_thai == "dang_xu_ly"
      ) {
        return "delayRed";
      } else if (Number(row.delayXuLy) > 7 && row.trang_thai == "dang_xu_ly") {
        return "delayPub";
      }
      if (
        Number(row.delayMoi) > 1 &&
        Number(row.delayMoi) <= 2 &&
        row.trang_thai == "moi"
      ) {
        return "delayYellow";
      } else if (
        Number(row.delayMoi) > 2 &&
        Number(row.delayMoi) <= 7 &&
        row.trang_thai == "moi"
      ) {
        return "delayRed";
      } else if (Number(row.delayMoi) > 7 && row.trang_thai == "moi") {
        return "delayPub";
      }
      return "";
    },
    forceUpdateUI() {
      this.$forceUpdate();
    },
    async fn_initTable() {
      let dataFilter = {
        filters: this.mData.tableRules.filters,
        fields:
          "id,ho_ten,dien_thoai,email,noi_dung,trang_thai,loai_loi_nhan,file_dinh_kem,thoi_diem_tao,thoi_diem_cap_nhat,nguoi_cap_nhat_id",
        //sort: "-thoi_diem_tao",
      };
      if (this.mData.tableRules.allowPaging) {
        dataFilter.limit = this.mData.tableRules.limit;
        dataFilter.offset = this.mData.tableRules.offset;
      }
      if (this.mData.tableRules.allowSorting) {
        dataFilter.sort = this.mData.tableRules.sort;
        // dataFilter.filters = this.mData.tableRules.filters;
      }
      if (this.mData.tableRules.showUrl) {
        this.$router
          .replace({
            name: "DanhSachLoiNhan",
            query: {
              limit: this.mData.tableRules.limit,
              page: this.mData.tableRules.page,
              sort: this.mData.tableRules.sort,
              filters: this.mData.tableRules.filters,
              showFormSearch: this.mData.tableRules.showFormSearch,
            },
          })
          .catch((err) => {});
      }
      try {
        let response = await mushroom.ldp_loi_nhan.listAsync(dataFilter, {
          cacheAge: 1,
        });
        if (response.result) {
          let today = new Date();

          response.result.forEach(async (item) => {
            item.urlDetailLink = ""; // link để dùng khi bấm chuột phải new tab
            // tính ngày delay trạng thái mới
            let dayDk = new Date(item.thoi_diem_tao);
            item.delayMoi =
              (today.getTime() - dayDk.getTime()) / (1000 * 3600 * 24);

            // tính ngày delay xử lý: thời điểm hiện tại trừ đi thời điểm phản hồi mới nhất
            item.delayXuLy = 0;
            const timePhanHoiMoiNhat =
              await mushroom.ldp_loi_nhan_phan_hoi.listAsync({
                fields:
                  "id,noi_dung,loi_nhan_id,nguoi_gui,thoi_diem_tao,nguoi_tao_id",
                filters: ["loi_nhan_id=" + item.id],
                sort: "-thoi_diem_tao",
              });
            console.log("timePhanHoiMoiNhat", timePhanHoiMoiNhat.result[0]);
            if (
              timePhanHoiMoiNhat.result &&
              timePhanHoiMoiNhat.result.length > 0
            ) {
              item.delayXuLy =
                (today.getTime() -
                  new Date(
                    timePhanHoiMoiNhat.result[0].thoi_diem_tao
                  ).getTime()) /
                (1000 * 3600 * 24);
            } else item.delayXuLy = 0;
          });
          this.loading = false;
          let resData = await this.fn_changeData(response.result);
          this.mData.tableRules.data = resData;
          this.mData.tableRules.total = response.meta.total;
          console.log("11", response, resData);
          this.mData.tableRules.page =
            response.meta.offset / response.meta.limit + 1;
          eventBus.$emit("goiLaiDemLoiNhan");
        }
      } catch (e) {
        console.log(e.code);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        }
      }
    },
    fn_tableSortChange(column) {
      if (column.order == "ascending") {
        this.mData.tableRules.sort = column.prop;
      } else if (column.order == "descending") {
        this.mData.tableRules.sort = "-" + column.prop;
      } else {
        this.mData.tableRules.sort = "";
      }
      this.fn_initTable();
    },
    async fn_hashUrl() {
      if (this.$route.query.limit) {
        this.mData.tableRules.limit = parseInt(this.$route.query.limit);
      }
      if (this.$route.query.page) {
        this.mData.tableRules.page = parseInt(this.$route.query.page);
      }
      if (this.$route.query.limit && this.$route.query.page) {
        this.mData.tableRules.offset =
          (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      }
      if (this.$route.query.sort) {
        this.mData.tableRules.sort = this.$route.query.sort;
        this.mData.tableRules.defaultSort[0] = this.mData.tableRules.sort;
        if (this.mData.tableRules.sort.indexOf("-") != -1) {
          this.mData.tableRules.defaultSort[1] = "descending";
        } else {
          this.mData.tableRules.defaultSort[1] = "ascending";
        }
      }
      if (this.$route.query.filters) {
        this.mData.tableRules.filters = this.$route.query.filters;
        // string to object
        this.mData.tableRules.dataSearch.value = MethodService.stringToObject(
          this.mData.tableRules.filters
        );
      }
      if (this.$route.query.showFormSearch) {
        if (this.$route.query.showFormSearch == "true") {
          this.mData.tableRules.showFormSearch = true;
        } else this.mData.tableRules.showFormSearch = false;
      }
    },
    fn_tableSizeChange(limit) {
      this.mData.tableRules.limit = limit;
      this.fn_tableChangeOffset(this.mData.tableRules.page);
    },
    fn_tableCurentChange(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tablePrevClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableNextClick(page) {
      this.fn_tableChangeOffset(page);
    },
    fn_tableChangeOffset(page) {
      this.mData.tableRules.page = page;
      this.mData.tableRules.offset =
        (this.mData.tableRules.page - 1) * this.mData.tableRules.limit;
      this.fn_initTable();
    },

    // tìm kiếm
    fn_tableShowFormSearch() {
      this.mData.tableRules.showFormSearch =
        !this.mData.tableRules.showFormSearch;

      this.$router.replace({
        name: "DanhSachLoiNhan",
        query: {
          limit: this.mData.tableRules.limit,
          page: this.mData.tableRules.page,
          sort: this.mData.tableRules.sort,
          filters: this.mData.tableRules.filters,
          showFormSearch: this.mData.tableRules.showFormSearch,
        },
      });
      this.fn_initTable(this.mData.tableRules.filters);
    },
    fn_tableSearch() {
      if (this.mData.tableRules.dataSearch.value["ho_ten"]) {
        this.mData.tableRules.dataSearch.value["ho_ten"] =
          this.mData.tableRules.dataSearch.value["ho_ten"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["dien_thoai"]) {
        if (
          this.mData.tableRules.dataSearch.value["dien_thoai"].slice(0, 1) == 0
        ) {
          this.mData.tableRules.dataSearch.value["dien_thoai"] =
            "84" +
            this.mData.tableRules.dataSearch.value["dien_thoai"].slice(1, 10);
        } else {
          this.mData.tableRules.dataSearch.value["dien_thoai"] =
            this.mData.tableRules.dataSearch.value["dien_thoai"].trim();
        }
      }
      if (this.mData.tableRules.dataSearch.value["email"]) {
        this.mData.tableRules.dataSearch.value["email"] =
          this.mData.tableRules.dataSearch.value["email"].trim();
      }
      if (this.mData.tableRules.dataSearch.value["noi_dung"]) {
        this.mData.tableRules.dataSearch.value["noi_dung"] =
          this.mData.tableRules.dataSearch.value["noi_dung"].trim();
      }

      this.$refs["myForm"].validate(async (valid) => {
        if (valid) {
          this.loading = true;
          this.mData.tableRules.filters = MethodService.filterTable(
            JSON.stringify(this.mData.tableRules.dataSearch)
          );
          this.mData.tableRules.offset = 0;
          MethodService.stopLadda();
          this.fn_initTable();
          console.log(this.mData.tableRules.filters);
          if (
            this.mData.tableRules.dataSearch.value["dien_thoai"].slice(0, 2) ==
            84
          ) {
            this.mData.tableRules.dataSearch.value["dien_thoai"] =
              "0" +
              this.mData.tableRules.dataSearch.value["dien_thoai"].slice(2, 12);
          }
          MethodService.stopLadda();
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    fn_date(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    // đổi lại số điện thoại 84 -> 0
    fn_changeData(data) {
      data.forEach((element) => {
        element.urlDetailLink =
          location.origin +
          this.$router.resolve({
            name: "FormLoiNhan",
            params: { id: element.id },
          }).href;

        element.dien_thoai = MethodService.formatPhone(element.dien_thoai);
      });
      return data;
    },
    // thay đổi lọc loại lời nhắn
    fn_changeLoaiLoiNhan(item) {
      this.fn_tableSearch();
    },
    fn_changeTrangThai(item) {
      this.fn_tableSearch();
    },
    // chi tiết, xóa bảng
    fn_handle(type, scope, row) {
      if (type == "detail") {
        this.urlDetail =
          location.origin +
          this.$router.resolve({
            name: "FormLoiNhan",
            params: { id: row.id },
          }).href;
      }
      if (type == "delete") {
        this.$confirm(LanguageService.lang.c_deleteConfirm, {
          confirmButtonText: LanguageService.lang.c_agree,
          cancelButtonText: LanguageService.lang.c_cancel,
          type: "warning",
        })
          .then(() => {
            this.fn_delete(row.id);
          })
          .catch((e) => {
            console.log(e);
          });
      }
    },
    async fn_update(type, scope, row) {
      const ldp_loi_nhan_object = {
        id: row.id, // required
        trang_thai: type,
      };
      try {
        const response = await mushroom.ldp_loi_nhan.partialUpdateAsync(
          ldp_loi_nhan_object
        );
        if (response.result == row.id) {
          this.fn_initTable(this.mData.tableRules.filters);
          window.toastr.success("Trạng thái cập nhật thành công");
        } else {
          window.toastr.warning("Dữ liệu không thay đổi");
        }
      } catch (e) {
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        } else {
          window.toastr.error("Đã có lỗi xảy ra. Hãy thử lại");
        }
      }
    },
    async fn_delete(id) {
      try {
        const response = await mushroom.ldp_loi_nhan.deleteAsync({ id: id });
        if (response.result) {
          window.toastr.success("Đã xóa lời nhắn thành công");
          this.fn_initTable();
        }
      } catch (e) {
        console.log(e);
        if (e.code === 4) {
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          window.toastr.error("Máy chủ không phản hồi");
          console.log(e);
        } else {
          window.toastr.error("Đã có lỗi xảy ra. Hãy thử lại");
        }
      }
    },

    // xóa nhiều lời nhắn
    handleSelectionChange(val) {
      this.multipleSelection = [];
      let arrayId = val;
      arrayId.forEach((item) => {
        this.multipleSelection.push(item.id);
      });
      console.log(this.multipleSelection);
    },

    async fn_removeMessages() {
      try {
        await mushroom.ldp_loi_nhan.batchDeleteAsync({
          ids: this.multipleSelection,
        });
        this.dialogThongBao = false;
        this.fn_initTable();
        window.toastr.success("Xóa nhiều lời nhắn thành công");
      } catch (e) {
        console.error("Có lỗi: %o", e);
        if (e.code === 4) {
          this.loading = false;
          window.toastr.error(this.aLang.no_server);
        } else if (e.code === 2) {
          this.loading = false;
          window.toastr.error("Máy chủ không phản hồi");
        } else window.toastr.error("Đã có lỗi xảy ra");
      }
    },

    // refreshData() {
    //   this.fn_initTable();
    //   setTimeout(() => {
    //     this.refreshData();
    //   }, 300000);
    // },
  },
  //run after render view
  async created() {
    await this.fn_hashUrl();
    //this.refreshData();
    await this.fn_initTable();
  },
  mounted() {},
};
</script>
<style scoped lang="scss">
.loiNhan {
  position: relative;
  padding: 10px;
}
.card {
  min-height: 88vh;
}
.card-header {
  background-color: #fafafa;
  border: 1px solid rgba(26, 54, 126, 0.125);
  border-bottom: none;
  text-align: center;
}
.title-body {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
}
.title-btn {
  margin-top: 10px;
}

.colorProcess,
.text-accept,
.text-ok,
.text-await,
.colorRed,
.colorYellow,
.colorPub {
  text-align: center;
  width: fit-content;
  border-radius: 5px;
  padding: 0 5px;
  color: #fff;
  min-width: 92px;
}
.text-box {
  display: flex;
  justify-content: center;
}
.text-accept,
.colorYellow {
  background-color: #e6a23c;
}
.el-table .colorProcess {
  background-color: #3cc;
}

.el-table .colorRed {
  background-color: #f56c6c;
}
.el-table .colorPub {
  background-color: #8443ff;
}
.el-table .text-ok {
  background-color: #67c23a;
}
.text-await {
  background-color: #409eff;
}
.text-landing,
.text-bao-loi,
.text-gop-y {
  width: fit-content;
  border-radius: 5px;
  padding: 0 5px;
  color: #fff;
  min-width: 92px;
}
.text-gop-y {
  /* background-color: #e6a23c; */
  background-color: #f3a261;
}
.text-bao-loi {
  /* background-color: #f56c6c; */
  background-color: #c31f22;
  opacity: 0.8;
}
.text-landing {
  /* background-color: #3cc; */
  background-color: #44bdaa;
}
::v-deep .el-table tbody tr:nth-of-type(even) {
  background-color: transparent;
}
::v-deep .delayYellow {
  background-color: #f7f097 !important;
}

::v-deep .delayRed {
  background-color: #ff8a7d !important;
}
::v-deep .delayPub {
  background-color: #dcaef1 !important;
}
::v-deep .delayYellow,
::v-deep .delayPub,
::v-deep .delayRed {
  font-size: 13px;
  color: #606266;
}

::v-deep .el-table td.el-table__cell,
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #d4d4d4;
}
::v-deep .el-table--border .el-table__cell,
::v-deep
  .el-table__body-wrapper
  .el-table--border.is-scrolling-left
  ~ .el-table__fixed {
  border-right: 1px solid #d4d4d4;
}
::v-deep .el-table__body tr.el-table__row:hover > td {
  background-color: inherit;
}
.table-group-btn {
  &__delete {
    width: 100%;
    margin-bottom: 10px;
  }
  &__trangThai,
  &__loiNhan {
    width: calc(50% - 5px);
    margin-bottom: 10px;
  }
  &__trangThai {
    margin-right: 5px;
  }
  &__loiNhan {
    margin-left: 5px;
  }
}

@media (min-width: 768px) {
  .table-group-btn {
    display: flex;
    &__delete {
      width: fit-content;
      margin-right: 10px;
    }
  }
}
@media (min-width: 960px) {
  .title-body {
    flex-direction: row;
  }
}
@media (min-width: 1200px) {
  .table-group-btn {
    &__trangThai,
    &__loiNhan {
      width: 175px;
    }
  }
}
</style>


